import API from '@/api'
import { LEAVE_ROLE } from '@/utils/constUtils'
export default {
  data() {
    return {
      LEAVE_ROLE,
      guardianCanAccess: true
    }
  },
  computed: {},
  watch: {},
  created() {},
  methods: {
    // 判断家长是否有操作权限
    async judgeCanAccessGuardian(studentDingId) {
      const _canAccess = studentDingId
        ? await this.judgeGuardian(studentDingId)
        : this.guardianCanAccess
      if (!_canAccess) {
        this.$Dialog({
          title: '付费开通',
          confirmBtn: {
            color: '#006afe',
            text: '我知道了'
          },
          content: `模块内容需付费后才能使用，请联系相关老师开通。`,
          onConfirm() {
            return false
          }
        }).show()
      }
      return _canAccess
    },
    // 判断家长是否有模块权限
    async judgeGuardian(studentDingId) {
      const _canAccess = await this.judgeGuardianSchoolAppAuth(studentDingId)
      this.guardianCanAccess =
        typeof _canAccess === 'boolean' ? _canAccess : false
      return this.guardianCanAccess
    },
    // 判断家长是否有使用魔点校园的权限
    judgeGuardianSchoolAppAuth(studentDingId) {
      return new Promise((resolve, reject) => {
        API.judgeGuardianSchoolAppAuth({
          operUserRoleTypes: '1',
          studentDingId
        })
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            console.log(err)
          })
      })
    }
  }
}
